import {
	get_load_type_desc,
	get_load_scope_desc,
	get_load_field_type_desc,
	get_area_type_desc,
	get_cycle_scope_desc,
	get_load_value_desc,
	get_rule_type_desc
} from './get_status_desc';

// LOAD_TYPE_NONE = 0
// LOAD_TYPE_CYCLE = 1
// LOAD_TYPE_SINGLE = 2 => Reestrucutra - Realiza cambios a las rutas
// LOAD_TYPE_UPDATE = 3 => Adicional - Agrega locations a las rutas
// LOAD_TYPE_VALUES = 4 => Coordenadas - Actualiza coordenadas a las tiendas
export const load_types_options = () => [
  get_load_type_desc(1),
	get_load_type_desc(2),
	get_load_type_desc(3),
	get_load_type_desc(4)
];

// LOAD_SCOPE_NONE = 0
// LOAD_SCOPE_GLOBAL = 1
// LOAD_SCOPE_ORGANIZATION = 2
// LOAD_SCOPE_WORKSPACE = 3
// LOAD_SCOPE_MODULE = 4
export const load_scope_options = () => [
  get_load_scope_desc(1),
	get_load_scope_desc(2),
	get_load_scope_desc(3),
	get_load_scope_desc(4)
];

// LOAD_SCHEMA_NONE = 0
// LOAD_SCHEMA_INT = 1
// LOAD_SCHEMA_FLOAT = 2
// LOAD_SCHEMA_STRING = 3
export const load_field_type_options = () => [
  get_load_field_type_desc(1),
	get_load_field_type_desc(2),
	get_load_field_type_desc(3)
];

// AREA_TYPE_NONE = 0
// AREA_TYPE_ORGANIZATION = 1
// AREA_TYPE_REGION = 2
// AREA_TYPE_ZONE = 3
// AREA_TYPE_DEPOT = 4
// AREA_TYPE_GROUP = 5
// AREA_TYPE_ROUTE = 6
// AREA_TYPE_LOCATION = 7
export const area_type_options = () => [
  get_area_type_desc(1),
	get_area_type_desc(2),
	get_area_type_desc(3),
	get_area_type_desc(4),
	get_area_type_desc(5),
	get_area_type_desc(6)
];

// CYCLE_SCOPE_NONE = 0
// CYCLE_SCOPE_COMPLETE = 1
// CYCLE_SCOPE_SELECTED = 2
export const cycle_scope_options = () => [
  get_cycle_scope_desc(1),
	get_cycle_scope_desc(2)
];

// LOAD_VALUE_NONE = 0
// LOAD_VALUE_REGION = 1
// LOAD_VALUE_ZONE = 2
// LOAD_VALUE_DEPOT = 3
// LOAD_VALUE_DATA = 4
// LOAD_VALUE_GROUP = 5
// LOAD_VALUE_ROUTE = 6
// LOAD_VALUE_LOCATION = 7
// LOAD_VALUE_NAME = 8
// LOAD_VALUE_DESCRIPTION = 9
// LOAD_VALUE_LAT = 10
// LOAD_VALUE_LON = 11
// LOAD_VALUE_USER = 12
// LOAD_VALUE_FREQUENCY = 13
export const load_value_options = () => [
	get_load_value_desc(1),
	get_load_value_desc(2),
	get_load_value_desc(3),
	get_load_value_desc(4),
	get_load_value_desc(5),
	get_load_value_desc(6),
	get_load_value_desc(7),
	get_load_value_desc(8),
	get_load_value_desc(9),
	get_load_value_desc(10),
	get_load_value_desc(11),
	get_load_value_desc(12),
	get_load_value_desc(13)
];

// LOAD_RULE_NONE = 0
// LOAD_RULE_MIN = 1
// LOAD_RULE_MAX = 2
// LOAD_RULE_VALUE = 3
// LOAD_RULE_OTHER = 4
// LOAD_RULE_COMPOSITE = 5
export const rule_type_options = () => [
  get_rule_type_desc(1),
  get_rule_type_desc(2),
  get_rule_type_desc(3),
  get_rule_type_desc(4),
  get_rule_type_desc(5)
];
